import { TeamMember } from '../types';

export const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: 'Shweta Goyal',
    position: 'Founder',
    bio: 'With over 15 years of experience in tech recruitment, I\'ve helped many startups find the right talent to scale their teams. My expertise lies in understanding both technical requirements and company culture to ensure perfect matches that drive growth.',
    image: 'https://res.cloudinary.com/dttkz0pie/image/upload/v1748523837/Shweta_Goyal_LinkedIn_ynmgxc.jpg',
    linkedin: 'https://www.linkedin.com/in/shweta-goyal-4209513/',
  },
];